import React from 'react';
import { observer } from 'mobx-react';
import { Link } from 'react-router-dom';

// Helpers
import { getURLSegment } from '../../helpers/helpers';

// Translations
import translate from '../Translate.js';

// Dependencies
import moment from 'moment';

// Components
import * as icons from '../Icons/Icons';
import MessageThread from './MessageThread';

const Inbox = observer(class Inbox extends React.Component {
  constructor() {
    super();
    this.toggleNav = this.toggleNav.bind(this);
    this.viewThread = this.viewThread.bind(this);
  }

  componentWillMount() {
    this.state = {
      messageSid: null,
      showNav: false
    }

    this.props.store.MessageStore.getThreads();

    // Load thread if there’s one in the URL
    if(getURLSegment(this, 2) === 'view' && getURLSegment(this, 3)) {
      this.setState({
        messageSid: getURLSegment(this, 3)
      });
    }
  }

  toggleNav() {
    this.setState({
      showNav: !this.state.showNav
    });
  }

  switchMailbox(e, mailbox) {
    e.preventDefault();

    // Unhighlight previously selected tab
    // const prevMailbox = document.querySelectorAll('.threads__switch .selected');
    //
    // prevMailbox.forEach(function(mailbox){
    //   if(mailbox) {
    //     mailbox.className = mailbox.className.replace('selected', '');
    //   }
    // })

    // Highlight newly selected tab
    e.target.className += ' selected';

    // Get new mailbox (not included yet since the API doesn’t exist)
  }

  viewThread(e, messageSid) {
    this.setState({
      messageSid
    });

    this.toggleNav();

    // Unhighlight any previously selected threads and
    const prevThread = document.querySelector('.thread.active');

    if(prevThread && prevThread.className.indexOf('active') > -1) {
      prevThread.className = prevThread.className.replace('active', '');
    }

    const thisThread = document.querySelector(`#thread-${messageSid}`);

    if(thisThread) {
      thisThread.className = thisThread.className.replace('thread--unread', '');
      thisThread.className += ' thread--read';
    }
  }

  renderSubject(thread) {
    const { translation } = this.props;

    let subject = null;

    if(thread.dateOption1) {
      subject = translation.subjects.session_request;
    } else if(thread.proctorApproval) {
      subject = translation.subjects.proctor_approval;
    } else if(thread.examSessionEventReport) {
      subject = translation.subjects.session_incident;
    } else if((thread.examConfiguration || thread.examSid) && thread.exam) {
      subject = thread.exam.title;
    }

    if(subject) {
      return (
        <span className="thread__subject" title={subject}>{subject}</span>
      )
    }

    return null;
  }

  render() {
    const { translation } = this.props;
    const { MessageStore, SessionStore} = this.props.store;
    const { threads } = MessageStore;

    const thisUserSid = SessionStore.userData.sid;

    return (
      <main tabIndex="0" id="main-content" className="page">
        <header className="page__header inbox-header">
          <div className="wrap">
            <h1 className="meta">{translation.page_title}</h1>

            {threads.length > 0 &&
              <button className="btn--outline inbox-nav-btn" onClick={this.toggleNav}>
                <icons.iconList />
                {translation.inbox_nav}
              </button>
            }
          </div>
        </header>

        <div className={`inbox ${this.state.showNav ? 'show-threads' : ''}`}>
          <section className="threads">
            <h2 className="meta">{translation.active_threads}</h2>

            {/* <ul className="toggle-list threads__switch">
              <li>
                <a
                  className="btn--neutral selected toggle-label"
                  href="#active-threads"
                  onClick={(e) => {this.switchMailbox(e, 'active')}}
                >Inbox</a>
              </li>
              <li>
                <a
                  className="btn--neutral toggle-label"
                  href="#archived-threads"
                  onClick={(e) => {this.switchMailbox(e, 'archive')}}
                >Archived</a>
              </li>
            </ul> */}

            {threads.length > 0 &&
              <ol id="active-threads" className="thread-list">
                {threads.map(
                  (thread, i) => {
                    let threadUserUnread = null;

                    if(thisUserSid === thread.initiatingUserSid) {
                      threadUserUnread = 'initiatingUserHasUnread';
                    } else {
                      threadUserUnread = 'proctorAccountUserHasUnread';
                    }

                    return (
                      <li key={i}>
                        <article id={`thread-${thread.sid}`} className={`thread ${thread[threadUserUnread] ? 'thread--unread' : 'thread--read'}`}>
                          <header id={`thread-${i}-title`} className="thread_header">
                            <h3 className="thread__title">
                              {thread.recipientFirstName} {thread.recipientLastName}
                            </h3>

                            {this.renderSubject(thread)}
                          </header>

                          <time className="thread__date">
                            {moment.utc(thread.lastMessageDate).local().format('M/D/YYYY')}
                          </time>

                          <Link
                            className="cover"
                            to={`/${getURLSegment(this, 1)}/view/${thread.sid}`}
                            onClick={(e) => {this.viewThread(e, thread.sid)}}
                            aria-labelledby={`thread-${i}-title`}
                          >
                            <span className="meta">{translation.view_thread}</span>
                          </Link>
                        </article>
                      </li>
                    )
                  }
                )}
              </ol>
            }
          </section>

          <section className="inbox__content">
            <h2 className="meta">{translation.inbox_content}</h2>

            {threads.length === 0 &&
              <span className="no-results">{translation.no_messages}</span>
            }

            {threads.length > 0 && this.state.messageSid &&
              <MessageThread messageSid={this.state.messageSid} inbox={this} {...this.props} />
            }

            {threads.length > 0 && !this.state.messageSid &&
              <span className="no-results">{translation.choose_thread}</span>
            }
          </section>
        </div>
      </main>
    )
  }
})

export default translate('Inbox')(Inbox);



// WEBPACK FOOTER //
// ./src/app/components/Messages/Inbox.js